module.exports = __webpack_public_path__ + "static/media/Menu.16b83cc5.svg";